module.exports = __webpack_public_path__ + "static/media/flecha.177f5fc2.svg";